import Logo from '../../../assets/CC ATS Logo.png'

function FloatingLoading() {
    return (
        <div className="fixed inset-0 bg-white/5 backdrop-blur-sm flex flex-col items-center justify-center z-50">
            {/* Spinner */}
            <div className="relative flex flex-col items-center">
                {/* Spinner circle */}
                <div className="animate-spin rounded-full h-36 w-36 border-[4px] border-t-primary-500 border-b-primary-500 border-l-primary-500 border-r-transparent"></div>

                {/* Large Logo below spinner */}
                <img src={Logo} alt="logo" className="absolute top-1/2 left-1/2 h-[80px] -translate-x-1/2 -translate-y-1/2
                     animate-pulse-slow " />
            </div>

            <p className="mt-6 text-primary-500 text-lg font-semibold tracking-wide">
                Please wait...
            </p>
        </div>
    )
}

export default FloatingLoading